/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnassignWorkScheduleCommand
 */
export interface UnassignWorkScheduleCommand {
    /**
     * 
     * @type {string}
     * @memberof UnassignWorkScheduleCommand
     */
    workScheduleRecordId: string;
    /**
     * 
     * @type {string}
     * @memberof UnassignWorkScheduleCommand
     */
    employeeId: string;
}

/**
 * Check if a given object implements the UnassignWorkScheduleCommand interface.
 */
export function instanceOfUnassignWorkScheduleCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "workScheduleRecordId" in value;
    isInstance = isInstance && "employeeId" in value;

    return isInstance;
}

export function UnassignWorkScheduleCommandFromJSON(json: any): UnassignWorkScheduleCommand {
    return UnassignWorkScheduleCommandFromJSONTyped(json, false);
}

export function UnassignWorkScheduleCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnassignWorkScheduleCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'workScheduleRecordId': json['workScheduleRecordId'],
        'employeeId': json['employeeId'],
    };
}

export function UnassignWorkScheduleCommandToJSON(value?: UnassignWorkScheduleCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'workScheduleRecordId': value.workScheduleRecordId,
        'employeeId': value.employeeId,
    };
}

